import React from "react";
import { Switch, useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import Authentication from "../pages/Authentication";
import PrivateRoute from "./components/PrivateRoute";
import MainNavigation from "./MainNavigation/index";
import Route from "./Route";
import { ROUTES } from "./routes";
import { api } from "../services/api";
import { logout } from "../store/actions/authActions";

const Routes: React.FC = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  api.interceptors.response.use(
    response => {
      return response;
    },
    error => {
      if (error?.response?.status === 403) {
        dispatch(logout(true));
        history.replace(ROUTES.AUTHENTICATION.path);
      }
      return Promise.reject(error);
    },
  );

  return (
    <>
      <Switch>
        <Route path={`/(login|${""})/`} exact component={Authentication} />
        {/* <Route
          path={ROUTES.AUTHENTICATION.path}
          exact
          component={Authentication}
        /> */}
        <PrivateRoute
          path={ROUTES.PEOPLE_MANAGEMENT.path}
          exact={false}
          component={MainNavigation}
        />
        <PrivateRoute
          path={ROUTES.PERSONNEL_DEPARTMENT_PANEL.path}
          exact={false}
          component={MainNavigation}
        />
      </Switch>
    </>
  );
};

export default Routes;
